import { ArrowDownTrayIcon } from '@heroicons/react/24/outline'
import { LayoutLoading } from 'components/LayoutLoading'
import { useEffect, useMemo, useState } from 'react'
import { downloadFciAttachments, downloadFile, getFciAttachments } from 'services'
import { PlainTable } from 'stories/components'
import { setLoanNumber } from 'utils/setLoanNumber'

import { renderFCIvalue } from '../constants'
import { tableBodyData, tableHeaders } from './constants'

export const FciAttachments = ({ servicerNo = 0 }: { servicerNo?: number }) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<Array<Record<string, any>>>([])

  const initData = async () => {
    setLoading(true)
    const res = await getFciAttachments(servicerNo)
    setData(res || [])
    setLoading(false)
  }

  useEffect(() => {
    setLoanNumber()
    initData()
  }, [])

  const onDownload = async (uid: string, name: string) => {
    setLoading(true)
    const pdfData = await downloadFciAttachments(uid)
    downloadFile(name, pdfData)
    setLoading(false)
  }

  const tableData = useMemo(() => {
    return data.map((item) => {
      return Object.keys(tableBodyData).map((key: string) => {
        if (key === 'name') {
          return (
            <div className="flex gap-1 items-center">
              <span
                className="px-1 py-1 rounded cursor-pointer hover-shadow1 text-shade-blue"
                onClick={() => onDownload(item.uid, item.name)}
              >
                <ArrowDownTrayIcon className="w-4 h-4" />
              </span>
              {renderFCIvalue(item[key], tableBodyData[key])}
            </div>
          )
        }
        return renderFCIvalue(item[key], tableBodyData[key])
      })
    })
  }, [data])

  return (
    <div className="fci-loan-detail-container px-2">
      <div className="max-w-screen-2xl m-auto">
        <div className="relative bg-white mt-6">
          <LayoutLoading show={loading} />
          <PlainTable header={tableHeaders} data={tableData} hasPagination />
        </div>
      </div>
    </div>
  )
}
